//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from '@/modules/partner/components/sama-el-baraka/header.vue';
import Footer from '@/modules/partner/components/sama-el-baraka/footer.vue';
import Title from '@/modules/partner/components/sama-el-baraka/title.vue';
import Products from '@/modules/partner/components/sama-el-baraka/products.vue';
import Branches from '@/modules/partner/components/sama-el-baraka/branches.vue';
import Contact from '@/modules/partner/components/sama-el-baraka/contact.vue';
import i18n from '@/vueI18n';
import { setPageMeta } from '@/shared/utils/meta-tags';
import { SAMA_BARAKA_LOGO } from '@/modules/partner/constants/sama-baraka-branding';

export default {
  components: {
    [Header.name]: Header,
    [Footer.name]: Footer,
    [Title.name]: Title,
    [Products.name]: Products,
    Branches,
    [Contact.name]: Contact,
  },
  computed: {
    language() {
      return i18n.locale;
    },
  },
  mounted() {
    this.updateMeta();
  },
  watch: {
    language() {
      document.title = this.i18n('app.samaElBaraka');
      this.updateMeta();
    },
  },
  methods: {
    updateMeta() {
      const lang = this.language || 'ar';
      setPageMeta({
        title: this.i18n('app.samaElBaraka'),
        description: `${this.$t('samaElBaraka.pageTitle.desc-1')} ${this.$t('samaElBaraka.pageTitle.desc-2')}`,
        url: `https://www.afigr.com/${lang}/sama-baraka`,
        image: `https://www.afigr.com${SAMA_BARAKA_LOGO}`,
        locale: lang,
      });
    },
    i18n(key, args) {
      return this.$t(key, args);
    },
  },
};
